import React from 'react';
import { _ } from '../../../functions/translator';

class SheetInfo extends React.Component{

    render(){

        let sheetValue = this.props.cardsGroup.attributes.sheet ? this.props.cardsGroup.attributes.sheet : _('Ninguna')

        let sheet = _("Lámina")

        if (this.props.customcard) {
            if (!this.props.customcard.attributes.sheet) return <div></div>
            sheet = this.props.customcard.attributes.sheet
        }

        return (
            <div className='info-container'>
                <p className='card-text'>{ sheet }</p>
                <span className='text card-description'>{ sheetValue }</span>
            </div>
        );
    }
}

export default SheetInfo;